/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const legalRegulatoryEnumsMandatoryReportingToAuthoritiesOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    Unknown: 'Unknown',
} as const;

export type LegalRegulatoryEnumsMandatoryReportingToAuthoritiesOptionEnumKey =
    (typeof legalRegulatoryEnumsMandatoryReportingToAuthoritiesOptionEnum)[keyof typeof legalRegulatoryEnumsMandatoryReportingToAuthoritiesOptionEnum];

export type LegalRegulatoryEnumsMandatoryReportingToAuthoritiesOption =
    LegalRegulatoryEnumsMandatoryReportingToAuthoritiesOptionEnumKey;
